"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GTag", {
    enumerable: true,
    get: function() {
        return GTag;
    }
});
var _loadGTag = require("./loadGTag");
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var GTag = function GTag(config) {
    "use strict";
    _class_call_check(this, GTag);
    _define_property(this, "identify", function(userId) {
        window.dataLayer.push(function() {
            this.set('userId', userId);
        });
        window.dataLayer.push({
            event: 'login',
            userId: userId
        });
    });
    // Not supported
    _define_property(this, "group", function() {});
    _define_property(this, "page", function(pageName) {
        var traits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        window.dataLayer.push({
            event: 'page_view',
            page_location: traits.path || location.pathname,
            page_title: pageName
        });
    });
    _define_property(this, "track", function(eventName) {
        var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var category = _param.category, traits = _object_without_properties(_param, [
            "category"
        ]);
        window.dataLayer.push(_object_spread({
            event: eventName,
            event_category: category || 'None'
        }, traits));
    });
    _define_property(this, "reset", function() {
        window.dataLayer.push(function() {
            this.reset();
        });
    });
    _define_property(this, "revenue", function(price, quantity, type) {
        var productId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '1', currency = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 'USD';
        window.dataLayer.push({
            event: 'revenue',
            page_location: location.pathname,
            price: price,
            quantity: quantity,
            type: type,
            currency: currency,
            productId: productId
        });
    });
    if (!config.trackingId) {
        throw new Error('TAG ID is required for gTag');
    }
    (0, _loadGTag.loadGTag)(config);
};
